import { intl } from "@fidget/common/i18n/TypedIntl";
import React from "react";
import sharedStyles from "../styles.css";

interface Props {
  agentGroups: string[];
}

export const AdviserAgentGroupsSummary = ({ agentGroups }: Props) => {
  const groupsJoined = agentGroups.join(", ");
  return (
    <div>
      <p className={sharedStyles["font-description"]} style={{ marginBottom: "8px" }}>
        {intl.formatMessage("settings.advisers.form.agentGroups.description")}
      </p>
      {agentGroups.length > 0 ? (
        <p className={sharedStyles["font-content"]}>{groupsJoined}</p>
      ) : (
        <p className={sharedStyles["missing-info"]}>
          {intl.formatMessage("settings.advisers.form.agentGroups.empty")}
        </p>
      )}
    </div>
  );
};
